import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- Hide any externally injected "Made with Emergent" badge ---
function stripEmergentBadge() {
  document
    .querySelectorAll(
      '#emergent-badge, a[id="emergent-badge"], a[href*="emergent-badge"]'
    )
    .forEach((el) => {
      try {
        el.remove();
      } catch {}
    });
}
// Run immediately, on DOM ready, and watch for re-injections.
stripEmergentBadge();
if (typeof MutationObserver !== "undefined") {
  const obs = new MutationObserver(stripEmergentBadge);
  obs.observe(document.documentElement, { childList: true, subtree: true });
}
window.addEventListener("DOMContentLoaded", stripEmergentBadge);
window.addEventListener("load", stripEmergentBadge);
// Fallback poll for the first 30 seconds in case the badge is re-injected
// by a script that wins a race with the observer.
let _badgeTicks = 0;
const _badgeInterval = setInterval(() => {
  stripEmergentBadge();
  _badgeTicks += 1;
  if (_badgeTicks > 60) clearInterval(_badgeInterval);
}, 500);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for PWA support
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

// Track visit count for the install prompt heuristic (2+ visits)
try {
  const visits =
    parseInt(localStorage.getItem("flowtasks_visits") || "0", 10) + 1;
  localStorage.setItem("flowtasks_visits", String(visits));
} catch {}
